export default "__VITE_ASSET__Db712oIE__"